/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import type { BadRequestResponse } from '../model/badRequestResponse';
import type { ForbiddenResponse } from '../model/forbiddenResponse';
import type { IpAddressRestrictionSetting } from '../model/ipAddressRestrictionSetting';
import type { NotFoundResponse } from '../model/notFoundResponse';
import type { UnauthorizedResponse } from '../model/unauthorizedResponse';
import type { UnprocessableEntityResponse } from '../model/unprocessableEntityResponse';
import type { UpdateIpAddressRestrictionSettingRequest } from '../model/updateIpAddressRestrictionSettingRequest';
import { useCustomClient } from '../../mutator/custom-instance';
import type { ErrorType, BodyType } from '../../mutator/custom-instance';
import { customFomDataFn } from '../../api/formData/custom-function';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P
) => any
  ? P
  : never;

/**
 * @summary Get IP address restriction setting
 */
export const useGetIpAddressRestrictionSettingHook = () => {
  const getIpAddressRestrictionSetting =
    useCustomClient<IpAddressRestrictionSetting>();

  return (
    options?: SecondParameter<ReturnType<typeof useCustomClient>>,
    signal?: AbortSignal
  ) => {
    return getIpAddressRestrictionSetting(
      { url: `/api/js/ip_address_restriction_setting`, method: 'GET', signal },
      options
    );
  };
};

export const getGetIpAddressRestrictionSettingQueryKey = () => {
  return [`/api/js/ip_address_restriction_setting`] as const;
};

export const useGetIpAddressRestrictionSettingQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetIpAddressRestrictionSettingHook>>
  >,
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetIpAddressRestrictionSettingHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetIpAddressRestrictionSettingQueryKey();

  const getIpAddressRestrictionSetting =
    useGetIpAddressRestrictionSettingHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetIpAddressRestrictionSettingHook>>
    >
  > = ({ signal }) => getIpAddressRestrictionSetting(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetIpAddressRestrictionSettingHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetIpAddressRestrictionSettingQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetIpAddressRestrictionSettingHook>>>
>;
export type GetIpAddressRestrictionSettingQueryError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
>;

/**
 * @summary Get IP address restriction setting
 */
export const useGetIpAddressRestrictionSetting = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetIpAddressRestrictionSettingHook>>
  >,
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetIpAddressRestrictionSettingHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetIpAddressRestrictionSettingQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetIpAddressRestrictionSettingSuspenseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetIpAddressRestrictionSettingHook>>
  >,
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetIpAddressRestrictionSettingHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetIpAddressRestrictionSettingQueryKey();

  const getIpAddressRestrictionSetting =
    useGetIpAddressRestrictionSettingHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGetIpAddressRestrictionSettingHook>>
    >
  > = ({ signal }) => getIpAddressRestrictionSetting(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGetIpAddressRestrictionSettingHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetIpAddressRestrictionSettingSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetIpAddressRestrictionSettingHook>>>
>;
export type GetIpAddressRestrictionSettingSuspenseQueryError = ErrorType<
  UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
>;

/**
 * @summary Get IP address restriction setting
 */
export const useGetIpAddressRestrictionSettingSuspense = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGetIpAddressRestrictionSettingHook>>
  >,
  TError = ErrorType<
    UnauthorizedResponse | ForbiddenResponse | NotFoundResponse
  >
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useGetIpAddressRestrictionSettingHook>>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGetIpAddressRestrictionSettingSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Update IP address restriction setting
 */
export const useUpdateIpAddressRestrictionSettingHook = () => {
  const updateIpAddressRestrictionSetting =
    useCustomClient<IpAddressRestrictionSetting>();

  return (
    updateIpAddressRestrictionSettingRequest: BodyType<UpdateIpAddressRestrictionSettingRequest>,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return updateIpAddressRestrictionSetting(
      {
        url: `/api/js/ip_address_restriction_setting`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: updateIpAddressRestrictionSettingRequest,
      },
      options
    );
  };
};

export const useUpdateIpAddressRestrictionSettingMutationOptions = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useUpdateIpAddressRestrictionSettingHook>>
    >,
    TError,
    { data: BodyType<UpdateIpAddressRestrictionSettingRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useUpdateIpAddressRestrictionSettingHook>>
  >,
  TError,
  { data: BodyType<UpdateIpAddressRestrictionSettingRequest> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const updateIpAddressRestrictionSetting =
    useUpdateIpAddressRestrictionSettingHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useUpdateIpAddressRestrictionSettingHook>>
    >,
    { data: BodyType<UpdateIpAddressRestrictionSettingRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return updateIpAddressRestrictionSetting(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateIpAddressRestrictionSettingMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useUpdateIpAddressRestrictionSettingHook>>
  >
>;
export type UpdateIpAddressRestrictionSettingMutationBody =
  BodyType<UpdateIpAddressRestrictionSettingRequest>;
export type UpdateIpAddressRestrictionSettingMutationError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Update IP address restriction setting
 */
export const useUpdateIpAddressRestrictionSetting = <
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useUpdateIpAddressRestrictionSettingHook>>
    >,
    TError,
    { data: BodyType<UpdateIpAddressRestrictionSettingRequest> },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useCustomClient>>;
}) => {
  const mutationOptions =
    useUpdateIpAddressRestrictionSettingMutationOptions(options);

  return useMutation(mutationOptions);
};
